/**
 * FastGPT 免登录分享页悬浮球（官方 /js/iframe.js）
 * 配置见 .env：VUE_APP_FASTGPT_BASE、VUE_APP_FASTGPT_SHARE_ID
 */
const SCRIPT_ID = "chatbot-iframe";
const BTN_ID = "fastgpt-chatbot-button";
const WIN_ID = "fastgpt-chatbot-window";

/** 是否启用（显式 true 或已填 base+shareId） */
export function isFastGptEnabled() {
  if (String(process.env.VUE_APP_FASTGPT_ENABLED || "").toLowerCase() === "false") {
    return false;
  }
  const base = (process.env.VUE_APP_FASTGPT_BASE || "").trim();
  const shareId = (process.env.VUE_APP_FASTGPT_SHARE_ID || "").trim();
  if (String(process.env.VUE_APP_FASTGPT_ENABLED || "").toLowerCase() === "true") {
    return !!(base && shareId);
  }
  return !!(base && shareId);
}

/** 拼装分享页 URL（可选 authToken 对接 FastGPT 身份鉴权） */
export function buildFastGptShareUrl(authToken) {
  const base = (process.env.VUE_APP_FASTGPT_BASE || "").replace(/\/+$/, "");
  const shareId = (process.env.VUE_APP_FASTGPT_SHARE_ID || "").trim();
  if (!base || !shareId) return "";

  const params = new URLSearchParams();
  params.set("shareId", shareId);
  const showHistory = process.env.VUE_APP_FASTGPT_SHOW_HISTORY;
  if (showHistory !== undefined && showHistory !== "") {
    params.set("showHistory", String(showHistory));
  } else {
    params.set("showHistory", "0");
  }
  if (authToken) {
    params.set("authToken", String(authToken));
  }
  return base + "/chat/share?" + params.toString();
}

function getScriptEl() {
  return document.getElementById(SCRIPT_ID);
}

/** 移除悬浮球与对话窗（切换用户 / 路由卸载时） */
export function unmountFastGptBot() {
  const btn = document.getElementById(BTN_ID);
  const win = document.getElementById(WIN_ID);
  if (btn) btn.remove();
  if (win) win.remove();
}

/**
 * 挂载或更新 FastGPT 悬浮球
 * @param {string} [authToken] 用户唯一标识，对应分享链接 authToken（商业版鉴权）
 */
export function mountFastGptBot(authToken) {
  if (!isFastGptEnabled()) return;

  const base = (process.env.VUE_APP_FASTGPT_BASE || "").replace(/\/+$/, "");
  const shareUrl = buildFastGptShareUrl(authToken);
  if (!shareUrl) {
    console.warn("[FastGPT] 缺少 VUE_APP_FASTGPT_BASE 或 VUE_APP_FASTGPT_SHARE_ID");
    return;
  }

  let script = getScriptEl();
  if (script) {
    script.setAttribute("data-bot-src", shareUrl);
    const iframe = document.getElementById(WIN_ID);
    if (iframe) iframe.src = shareUrl;
    if (!document.getElementById(BTN_ID) && typeof window.embedChatbot === "function") {
      window.embedChatbot();
    }
    return;
  }

  unmountFastGptBot();
  script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.defer = true;
  script.src = base + "/js/iframe.js";
  script.setAttribute("data-bot-src", shareUrl);
  script.setAttribute("data-default-open", process.env.VUE_APP_FASTGPT_DEFAULT_OPEN || "false");
  script.setAttribute("data-drag", process.env.VUE_APP_FASTGPT_DRAG !== "false" ? "true" : "false");
  const themeColor = process.env.VUE_APP_FASTGPT_THEME_COLOR;
  if (themeColor) script.setAttribute("data-color", themeColor);

  script.onload = function onFastGptScriptLoad() {
    if (typeof window.embedChatbot === "function") {
      window.embedChatbot();
    }
  };
  script.onerror = function () {
    console.error("[FastGPT] 加载失败:", script.src);
  };

  document.body.appendChild(script);
}
